export default __webpack_public_path__ + "static/media/sprint_review.ca8e225a.png";